<template>
  <div class="divInfo">
        <v-container>
            <v-row no-gutters>
                <v-col cols="12" class="my-0">
                    <v-text-field v-show="novaPergunta" dense label="Titulo" outlined v-model="tituloNovaPergunta"></v-text-field>
                    <v-textarea v-show="novaPergunta" label="Texto" outlined v-model="textoNovaPergunta"></v-textarea>
                </v-col>
                <v-col col="12" class="col-md-12 text-center">
                    <v-btn v-if="!novaPergunta" class="my-0" color="primary" @click="novaPergunta = true">Nova Pergunta</v-btn>
                    <div v-else>
                        <v-btn class="my-0" color="primary" @click="salvarNovaPergunta()">Salvar</v-btn>
                        <v-btn class="my-0 ml-4" color="primary" @click="novaPergunta = false">Cancelar</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" class="col-md-8 mx-auto py-4">
                        <v-card color="transparent" class="my-4" v-for="p in this.perguntas" :key="p.id">
                            <v-card-title class="mb-5" style="background-color: rgba(200, 200, 200, 1);">
                                <p class="my-0 h2 font-weight-black">{{p.titulo}}</p>
                                <v-spacer></v-spacer>
                                <v-chip small color="primary">{{p.respostas.length}} respostas</v-chip>
                            </v-card-title>
                            <v-card-text class="">
                                <v-row no-gutters>
                                    <v-col cols="12" class="mb-6">
                                        <p class="body-1 font-weight-bold">{{p.pergunta}}</p>
                                    </v-col>
                                    <v-col cols="2" class="text-center">
                                        <v-avatar class="mx-auto" color="primary" size=32></v-avatar>
                                    </v-col>
                                    <v-col cols="10" class=" mx-0 text-left">
                                        <v-divider></v-divider>
                                        <div class=" body-2 mx-4">
                                        {{p.nome_usuario}} 
                                        <br> 
                                        {{p.data_pergunta}}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-expand-transition>
                                <div>
                                    <v-col v-show="p.verRespostas" class="col-md-10 mx-auto" v-for="r in p.respostas" :key="r.id">
                                        <v-card color="transparent" flat tile style="border-bottom: 1px solid black">
                                            <v-card-text>
                                                <v-row no-gutters>
                                                    <v-col cols="12" class="mb-4">
                                                        <p class="title font-weight-bold body-1">{{r.resposta}}</p>
                                                    </v-col>
                                                    <v-col cols="10" class="text-right">
                                                        <v-divider></v-divider>
                                                        <div class=" body-2 mx-0">
                                                            {{r.nome_usuario}}
                                                            <br>
                                                            {{r.data_resposta}}
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="2" class="text-right">
                                                        <v-avatar class="mx-auto" color="primary" size=32></v-avatar>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-divider></v-divider>
                                    <v-col v-show="p.responder">
                                        <v-textarea v-model="p.novaResposta" outlined></v-textarea>
                                    </v-col>
                                </div>
                            </v-expand-transition>
                            <v-divider></v-divider>
                            <v-card-actions class="pa-0" style="background-color: rgba(200, 200, 200, 1)">
                                <v-container fluid class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="12" class="text-center">
                                            <v-btn v-if="!p.responder" text color="primary" @click="p.responder = !p.responder">Responder</v-btn>
                                            <div v-else>
                                                <v-btn text color="primary" @click="salvarResposta(p)">Salvar</v-btn>
                                                <v-btn text color="primary" @click="p.responder = false">Cancelar</v-btn>
                                            </div>
                                            <v-btn v-show="p.respostas.length > 0" text color="primary" @click="p.verRespostas = !p.verRespostas">{{p.verRespostas ? 'Esconder respostas' : 'Ver Respostas'}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-actions>                                            
                        </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import { baseApiUrl, showError, showSuccess } from "@/config/global"

export default {
    props:['aula'],
    data(){
        return{
            textoNovaPergunta: '',
            tituloNovaPergunta: '',
            novaPergunta: false,
            perguntas: {},
            respostas: {},
            ativar: false,
        }
    },
    computed:{
        ...mapState(['user']),
    },
    methods:{
        salvarNovaPergunta(){
            if(this.textoNovaPergunta.length > 0 && this.tituloNovaPergunta.length > 0){
                const url = `${baseApiUrl}/Cursos/insertNovaPergunta.php`
                
                axios.post(url, {pergunta: this.textoNovaPergunta, titulo: this.tituloNovaPergunta, user: this.user.user, aula: this.aula.id})
                .then(res => {
                    if(res.data.codigo == '01'){
                        
                        this.textoNovaPergunta = ''
                        this.tituloNovaPergunta = ''
                        this.novaPergunta = false
                        let pg = res.data.pergunta
                        pg[0].verRespostas = false
                        pg[0].responder = false
                        pg[0].novaResposta = ''
                        
                        if(Object.keys(this.perguntas).length > 0){
                            this.perguntas.unshift(pg[0])
                        }else{
                            this.perguntas = pg
                        }

                        showSuccess(res.data.mensagem)
                    }
                })
                
            }else{
                showError("Pergunta ou titulo não informados!")
            }
        },

        salvarResposta(pergunta){
            if(pergunta.novaResposta.length > 0){
                const url = `${baseApiUrl}/Cursos/insertNovaResposta.php`
                axios.post(url, pergunta).then(res => {
                    if(res.data.codigo == '01'){
                        pergunta.novaResposta = ''
                        showSuccess(res.data.mensagem)
                        pergunta.respostas.unshift(res.data.resposta)
                        pergunta.responder = false
                        pergunta.verRespostas = true
                    }
                })
            }else{
                showError("Resposta não informada!")
            }
        },

        carregarPerguntas(){

            if(!this.perguntas.length > 0){
                
                const url = `${baseApiUrl}/Cursos/readPerguntas.php?idAula=${this.aula.id}`
                
                axios.get(url).then(res => {
                    
                    if(res.data.codigo == '01'){
                        this.perguntas = res.data.perguntas.map(m => {
                            return {
                                ...m,
                                verRespostas: false,
                                responder: false,
                                novaResposta: '',
                            }
                        })
                    }
                })
            }
        },

    },

    created(){
        this.carregarPerguntas(this.aula.id)
    }
}
</script>

<style scoped>
    .divInfo{
        width: 100%;
        height: 100%;
        margin-top: 30px;
        
    }
</style>